/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Timer_StartInputs */

const en_timer_start = /** @type {(inputs: Timer_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start timer · ${i?.time}`)
};

const de_timer_start = /** @type {(inputs: Timer_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer starten · ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Start timer · {time}" |
*
* @param {Timer_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const timer_start = /** @type {((inputs: Timer_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_timer_start(inputs)
	return en_timer_start(inputs)
});